module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"history":"History","cancel":"Cancel","restore":"Restore","are_you_sure":"Are you sure?","agree":"Agree"},"de":{"history":"Geschichte","cancel":"Stornieren","restore":"Wiederherstellen","are_you_sure":"Bist du sicher?","agree":"Stimme zu"}}')
  delete Component.options._Ctor
}
